import axios from '@/utils/axios'
import useGTag from '@/composables/gtm-gtag'
import useFacebook from '@/composables/facebook'

import { defineStore } from 'pinia'
import { getSavedState, saveState } from '@/utils/helper'
import { useNotificationStore } from './notification'

export const useCharityStore = defineStore('charity', {
  state: () => ({
    charity_info: getSavedState('charity.Info')
  }),
  getters: {
    getCharityInfo(state) {
      return state.charity_info
    },
    getCharityId() {
      return this.getCharityInfo?.charity_id
    }
  },
  actions: {
    async getWhiteLabel(domain) {
      const { initGTag } = useGTag()
      const { initPixel } = useFacebook()
      return axios
        .get(`/whitelabel/${domain}/config`)
        .then((Response) => {
          this.setCharityInfo(Response.data)
          if (Response.data.addons?.facebook_pixel) {
            initPixel(Response.data.addons?.facebook_pixel)
          }

          // Check for the `google_analytics` configuration, otherwise fallback to the legacy `google_tag_manager` option.
          if (Response.data.addons?.google_analytics || Response.data.addons?.google_tag_manager) {
            initGTag(
              Response.data.addons?.google_analytics || Response.data.addons?.google_tag_manager
            )
          }
          return Response.data
        })
        .catch((Error) => {
          const notification = useNotificationStore()
          notification.getNotificationError(Error)
          return Promise.reject(Error)
        })
    },
    setCharityInfo(data) {
      this.charity_info = data
      saveState('charity.Info', data)
    }
  }
})
